const backgroundPosition = {
  name: "background-position",
  path: "/background-position",
  title: "background-position",
  description: "Utilities for controlling an element's background position.",
  value: {
    "background-position": {
      "bg-center": "center",
      "bg-top": "top",
      "bg-bottom": "bottom",
      "bg-left": "left",
      "bg-right": "right",
      "bg-top-left": "top left",
      "bg-top-right": "top right",
      "bg-bottom-left": "bottom left",
      "bg-bottom-right": "bottom right",
      "bg-position-[<value>]": "<value>"
    }
  },
  exampleData: [
{
            "title": "bg-center, bg-right , bg-top-left",
            "description": "to control the position of an element's background image:",
            "moreDescription": "",
            "parentClass": "!bg-none flex snap-x scroll-p-4 items-end overflow-x-scroll overflow-y-hidden p-8 py-12 sm:grid sm:grid-columns-3 sm:gap-16",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute top-0 left-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-top-left",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-top-left bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute top-0 -left-4 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-top",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-top bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute top-0 right-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-top-right",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-top-right bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute -top-4 left-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-left",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-left bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute -top-4 -left-4 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-center",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-center bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute -top-4 right-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-right",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-right bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute bottom-0 left-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-bottom-left",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-bottom-left bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute bottom-0 -left-4 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-bottom",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-bottom bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM",
                        "className": "absolute bottom-0 right-0 h-32 w-32 max-w-none overflow-hidden rounded-md opacity-0 sm:group-hover:opacity-25",
                        "text":"bg-bottom-right",
                        "textClass":"absolute whitespace-nowrap font-sans font-regular -top-7 left-0 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative z-10 size-24 rounded-md bg-size-[8rem] bg-bottom-right bg-image-[url(https://fastly.picsum.photos/id/164/200/200.jpg?hmac=UA4QhIt441pdFJ6Uam2yCxzda_KjWgQgy8fYs_-NFEM)]"
                    },
                ],
                "className": "group relative mx-auto h-24 w-24 rounded-lg",
                "code": `
<div class="bg-[url(/img/mountains.jpg)] bg-top-left"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-top"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-top-right"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-left"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-center"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-right"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-bottom-left"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-bottom"></div>
<div class="bg-[url(/img/mountains.jpg)] bg-bottom-right"></div>
                `
            },
        },
        {
            "title": "bg-position-[<value>]",
            "description": "syntax to set the background position based on a completely custom value:",
            "example": {
                "code": `
<div class="bg-position-[50%_100%] ...">
  <!-- ... -->
</div>>
                `
            },
        }
  ],
};

export default backgroundPosition;

<div className="md:grid-columns-3 bg-center bg-top bg-bottom bg-left bg-right bg-top-left bg-top-right bg-bottom-left bg-bottom-right"></div>